import { render, staticRenderFns } from "./MogishikenDetailTable.vue?vue&type=template&id=631ceaca&scoped=true"
import script from "./MogishikenDetailTable.vue?vue&type=script&lang=ts"
export * from "./MogishikenDetailTable.vue?vue&type=script&lang=ts"
import style0 from "./MogishikenDetailTable.vue?vue&type=style&index=0&id=631ceaca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ceaca",
  null
  
)

export default component.exports